import { connect } from "react-redux";
import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
// NOTIFICATION SYSTEM TEMPORARILY DISABLED
// import { NotificationProvider } from "./contexts/NotificationContext";
import Protect from "./components/Protect";
import Home from "./pages/Home/Home";
import ProfileView from "./pages/Profile/ProfileView";
import ProfileEdit from "./pages/Profile/ProfileView";

import Login from "./pages/Login/Login";
import Register from "./pages/Register/Register";

import ReportHome from "./pages/Report/ReportHome";
import ReportTags from "./pages/Report/ReportTags";
import ReportMeta from "./pages/Report/ReportMeta";
import ReportFile from "./pages/Report/ReportFile";
import ReportSearch from "./pages/Report/ReportSearch";
import ReplaceTags from "./pages/Report/ReplaceTags";
import ReportSummerizeFile from "./pages/Report/ReportSummerizeFile";
import ReportSummerizeSeo from "./pages/Report/ReportSummerizeSeo";
import ReportTagsManagement from './pages/Report/ReportTagsManagement';

//resource route
//import ResourceList from "./pages/Resource/ResourceList";
import ResourceGrid from "./pages/Resource/ResourceGrid";
import ResourceCreate from "./pages/Resource/ResourceCreate";
import ResourceEdit from "./pages/Resource/ResourceEdit";
import ResourceDetail from "./pages/Resource/ResourceDetail";
import ResourcesImageProcess from "./pages/Resource/ResourcesImageProcess";
import ResourcesFileProcess from "./pages/Resource/ResourcesFileProcess";
import ResourcesSocial from "./pages/Resource/ResourcesSocial";
import ResourcesTags from "./pages/Resource/ResourcesTags";
import SimilarImage from "./pages/Search/SimilarImage";
import SimilarResource from "./pages/Search/SimilarResource";

//collection route
import CollectionDetail from "./pages/Collection/CollectionDetail";
import CollectionEdit from "./pages/Collection/CollectionEdit";
import CollectionList from "./pages/Collection/CollectionList"; // Import the new page

// event route
import EventList from "./pages/Event/EventList";
import EventCreate from "./pages/Event/EventCreate";
import EventDetail from "./pages/Event/EventDetail";
import EventEdit from "./pages/Event/EventEdit";

//user route
import UserList from "./pages/User/UserList";
import UserCreate from "./pages/User/UserCreate";
import UserEdit from "./pages/User/UserEdit";
import UserDetail from "./pages/User/UserDetail";

//contact
//user route
import ContactList from "./pages/Contact/ContactList";
import ContactDetail from "./pages/Contact/ContactDetail";

import FileList from "./pages/File/FileList";
import OrderList from "./pages/Order/OrderList";
import PaymentList from "./pages/Payment/PaymentList";
import OrderDetail from "./pages/Order/OrderDetail";
import OrderEdit from "./pages/Order/OrderEdit";
import InvoiceDetail from "./pages/Invoice/InvoiceDetail";
import FileDetail from "./pages/File/FilesDetail";
import ResourcesConvertFile from "./pages/Resource/ResourcesConvert";
import ResourcesBulkEdit from "./pages/Resource/ResourcesBulkEdit";
import ResourcesCollection from "./pages/Resource/ResourcesCollection";
import ResourcesCreateCollection from "./pages/Resource/ResourcesCreateCollection";
// import ResourceConvertList from "./pages/Convert/ResourceConvertList";
// import ResourceConvertEdit from "./pages/Convert/ResourceConvertEdit";

const App = () => {
  useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client-overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
  }, []);

  return (
    <div>
      {/* {!token ? ( */}
      {/* <Layout> */}
      <Routes>
        <Route exact path="/login" element={<Login/>}/>
        <Route exact path="/register" element={<Register/>}/>
        <Route
          path="*"
          element={
            <main style={{ padding: "1rem" }}>
              <h1 className="p5 text-center">404</h1>
            </main>
          }
        />

        <Route exact element={<Protect/>}>
          {/* protect router */}
          <Route exact path="/" element={<Home/>}/>
          <Route path="/resources">
            {/* <Route index element={<ResourceList />} /> */}
            <Route index element={<ResourceGrid/>}/>
            <Route exact path="new" element={<ResourceCreate/>}/>
            <Route exact path="view/:id" element={<ResourceDetail/>}/>
            <Route exact path="edit/:id" element={<ResourceEdit/>}/>
            <Route exact path="processImage" element={<ResourcesImageProcess/>}/>
            <Route exact path="socialPost" element={<ResourcesSocial/>}/>
            <Route exact path="processCollection" element={<ResourcesCollection/>}/>
            <Route exact path="createCollection" element={<ResourcesCreateCollection/>}/>
            <Route exact path="processFile" element={<ResourcesFileProcess/>}/>
            <Route exact path="processTag" element={<ResourcesTags/>}/>
            <Route
              exact
              path="convert-file"
              element={<ResourcesConvertFile/>}
            />
            <Route exact path="bulkEdit" element={<ResourcesBulkEdit/>}/>
            <Route path="/resources/search" element={<SimilarImage />} />
            <Route exact path="similar" element={<SimilarResource />} />
          </Route>
          <Route path="/collections">
            <Route index element={<CollectionList/>}/> {/* Add this line */}
            <Route exact path="view/:id" element={<CollectionDetail/>}/>
            <Route exact path="edit/:id" element={<CollectionEdit/>}/>
          </Route>
          <Route path="/files">
            <Route index element={<FileList/>}/>
            <Route exact path="view/:id" element={<FileDetail/>}/>
            {/* <Route exact path="new" element={<FileCreate />} />
              <Route exact path="edit/:id" element={<FileEdit />} /> */}
          </Route>
          <Route path="/events">
            <Route index element={<EventList/>}/>
            <Route exact path="new" element={<EventCreate/>}/>
            <Route exact path="view/:id" element={<EventDetail/>}/>
            <Route exact path="edit/:id" element={<EventEdit/>}/>
          </Route>
          <Route path="/contacts">
            <Route index element={<ContactList/>}/>
            <Route exact path="view/:id" element={<ContactDetail/>}/>
            {/* <Route exact path="new" element={<FileCreate />} />
              <Route exact path="edit/:id" element={<FileEdit />} /> */}
          </Route>
          <Route path="/orders">
            <Route index element={<OrderList/>}/>
            <Route exact path="edit/:id" element={<OrderEdit/>}/>
            <Route exact path="view/:id" element={<OrderDetail/>}/>
          </Route>

          <Route path="/reports">
            <Route index element={<ReportHome/>}/>
            <Route exact path="tags" element={<ReportTags/>}/>
            <Route exact path="tagReplace" element={<ReplaceTags/>}/>
            <Route exact path="meta" element={<ReportMeta/>}/>
            <Route exact path="file-report" element={<ReportFile/>}/>
            <Route exact path="search" element={<ReportSearch/>}/>
            <Route exact path="file-summary" element={<ReportSummerizeFile/>}/>
            <Route exact path="seo" element={<ReportSummerizeSeo/>}/>
            <Route exact path="tags-management" element={<ReportTagsManagement/>}/>
          </Route>

          {/* <Route path="/convert">
            <Route index element={<ResourceConvertList/>}/>
            <Route exact path="edit/:id" element={<ResourceConvertEdit/>}/>
          </Route> */}

          <Route path="/invoices">
            <Route index element={<InvoiceDetail/>}/>
          </Route>
          
          <Route path="/payments">
            <Route index element={<PaymentList/>}/>
            {/* <Route exact path="new" element={<FileCreate />} />
              <Route exact path="edit/:id" element={<FileEdit />} /> */}
          </Route>
          <Route path="/users">
            <Route index element={<UserList/>}/>
            <Route exact path="new" element={<UserCreate/>}/>
            <Route exact path="edit/:id" element={<UserEdit/>}/>
            <Route exact path="view/:id" element={<UserDetail/>}/>
            <Route path="*" element={<Navigate to="list"/>}/>
          </Route>
          <Route path="/profile">
            <Route index element={<ProfileView/>}/>
            <Route exact path="settings" element={<ProfileEdit/>}/>
          </Route>
          <Route
            path="*"
            element={
              <main style={{ padding: "1rem" }}>
                <h1 className="p5 text-center">404</h1>
              </main>
            }
          />
        </Route>
      </Routes>
    </div>
    // </NotificationProvider>
  );
};

function mapStateToProps(state) {
  const { user } = state.auth;
  const { message } = state.message;
  return {
    user,
    message
  };
}

export default connect(mapStateToProps)(App);
